import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

// Global styles
const style = document.createElement('style')
style.textContent = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { 
    background-color: #0a0f1a; 
    color: #ffffff;
    font-family: 'Barlow', sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  input:focus { border-color: rgba(180,140,60,0.5) !important; }
  button:hover { opacity: 0.9; }
  a { text-decoration: none; color: inherit; }
  ::-webkit-scrollbar { width: 4px; height: 4px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 2px; }

  /* Mobile sidebar hide, bottom nav show, top bar show */
  @media (max-width: 768px) {
    aside { display: none !important; }
    main { margin-left: 0 !important; }
    nav[data-mobile-bottom] { display: flex !important; }
    div[data-topbar] { display: flex !important; }
  }
`
document.head.appendChild(style)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<React.StrictMode><App /></React.StrictMode>)
